/**
 * вернет true, если входной параметр является *falsy* значением
 * (за исключением значений типа `number` или `boolean`), пустым массивом или пустым объектом.
 *
 * @param checkBoolean - включить проверку на false значение.
 */
export function isFalsyValue(val: any, checkBoolean = false) {
    if (val === null || val === undefined) return true;

    const isEmptyObject = typeof val === 'object' && !Object.keys(val).length;
    const isEmptyArray = Array.isArray(val) && !val.length;
    const isFalsyValue = typeof val !== 'number' && typeof val !== 'boolean' && !val;
    const isFalse = checkBoolean && val === false;

    return isEmptyObject || isEmptyArray || isFalsyValue || isFalse;
}
